import { getTokenDefinition, getValidChainId, } from "@bracket/chainography";
import * as ER from "@bracket/contractor-next/erc20";
import type { TokenIdentifier, } from "@bracket/types";
import { deepAssign, } from "@utils";
import { wagmiConfig as config, } from "@wagmiconfig";
import { cache, initialTokenCache, } from "./cache";



export const balanceOfWallet = async ({
	token,
}: {
	token?: TokenIdentifier;
}): Promise<bigint> => {
	const now = Date.now();
	const tok = getTokenDefinition(token || { symbol: "BRKTETH", chainId: getValidChainId(config), });
	cache.tokens[tok.symbol] = cache.tokens[tok.symbol] || deepAssign({}, initialTokenCache);
	const {
		time,
		value,
		since,
	} = cache.tokens[tok.symbol].balance_of;
	if(since > now - time) {
		return value;
	}
	const next = await ER.balanceOf({ token: tok, config, });
	cache.tokens[tok.symbol].balance_of.since = Date.now();
	cache.tokens[tok.symbol].balance_of.value = next as bigint;
	return next;
}
